module.exports = __webpack_public_path__ + "static/media/extract-pkg.4f64732e.svg";